<template>
    <app-button class="theme-switch" @click="handleButtonClick">
        <app-icon value="icon-sun"
                  :class="sunIconClassName"
        />
        <app-icon value="icon-moon"
                  :class="moonIconClassName"
        />
    </app-button>
</template>

<script>
    import AppIcon from '../AppIcon'
    import AppButton from '../AppButton'

    export default {
        name: "ThemeSwitch",
        props: {
            mode: {
                type: String,
                default: 'light'
            }
        },
        computed: {
            sunIconClassName() {
                const {mode} = this
                const show = mode !== 'dark'
                return {
                    'theme-switch__icon': true,
                    hide: !show,
                    show: show,
                }
            },
            moonIconClassName() {
                const {mode} = this
                const show = mode === 'dark'
                return {
                    'theme-switch__icon': true,
                    hide: !show,
                    show: show,
                }
            }
        },
        methods: {
            handleButtonClick() {
                this.$emit('change')
            }
        },
        components: {
            AppButton,
            AppIcon
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .theme-switch {
        display: inline-block;
        position: relative;
        width: 40px;
        height: 40px;
        font-size: $fontSizeCommon;
        font-weight: $fontWeightBolder;

        &__icon {
            position: absolute;
            left: (40px - $fontSizeCommon)/2;
            top: (40px - $fontSizeCommon)/2;
        }

        .show {
            animation: show-icon 300ms forwards;
        }

        .hide {
            animation: hide-icon 300ms forwards;
        }
    }


    @keyframes show-icon {
        from {
            opacity: 0;
            transform: scaleY(0);
            // transform: translate3d(-100%, 10px, 0) rotate(-180deg) scale3d(0.5, 0.5, 0.5);
        }
        to {
            opacity: 1;
            transform: scaleY(1);
            // transform: translate3d(0, 0, 0) rotate(0) scale3d(1, 1, 1);
        }
    }

    @keyframes hide-icon {
        from {
            opacity: 1;
            transform: scaleY(1);
            // transform: translate3d(0, 0, 0) rotate(0) scale3d(1, 1, 1);
        }
        to {
            opacity: 0;
            transform: scaleY(0);
            // transform:  translate3d(100%, 10px, 0) rotate(180deg) scale3d(0.5, 0.5, 0.5);
        }
    }
</style>